(() => {
  const bar = document.querySelector('[data-halo-market]');
  if (!bar) return;
  const automaticForm = document.getElementById('HaloAustraliaLocalization');
  const error = bar.querySelector('[data-market-error]');
  const url = new URL(window.location.href);
  const explicitAustralia = url.searchParams.get('bh_country') === 'AU';
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch { /* URL marker also prevents loops. */ } }
  };
  const showError = () => { error.hidden = false; error.tabIndex = -1; error.focus(); };
  let manualSelection = false;
  document.querySelectorAll('.market-form').forEach(form => {
    const select = form.elements.country_code;
    if (!select) return;
    form.addEventListener('submit', () => {
      manualSelection = true;
      storage.set('halo-country-choice', select.value);
      const destination = new URL(window.location.href);
      destination.searchParams.delete('bh_country');
      destination.searchParams.delete('bh_au_attempt');
      if (form.elements.return_to) form.elements.return_to.value = destination.pathname + destination.search + destination.hash;
    });
    select.addEventListener('change', () => form.requestSubmit());
    // Hide the fallback button only once automatic submission is available.
    form.classList.add('halo-country-auto');
  });
  const switchToAustralia = () => {
    if (!automaticForm) { showError(); return false; }
    if (url.searchParams.has('bh_au_attempt') || storage.get('halo-au-attempt') === '1') {
      showError(); return false;
    }
    storage.set('halo-au-attempt', '1');
    url.searchParams.delete('bh_country');
    url.searchParams.set('bh_au_attempt', '1');
    automaticForm.elements.return_to.value = url.pathname + url.search + url.hash;
    automaticForm.submit();
    // The navigation must finish before a purchase can start in the old market.
    return new Promise(() => {});
  };
  window.haloMarketReady = (async () => {
    if (bar.dataset.designMode === 'true') return true;
    if (bar.dataset.country === 'AU') {
      if (bar.dataset.currency !== 'AUD') { showError(); return false; }
      storage.set('halo-au-attempt', '0');
      if (url.searchParams.has('bh_au_attempt') || explicitAustralia) {
        url.searchParams.delete('bh_au_attempt'); url.searchParams.delete('bh_country');
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
      return true;
    }
    if (explicitAustralia) return switchToAustralia();
    if (storage.get('halo-country-choice')) return true;
    if (!automaticForm) return true;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { signal: controller.signal });
      if (!response.ok) return true;
      const suggestions = await response.json();
      if (!manualSelection && suggestions.detected_values?.country?.handle === 'AU') return switchToAustralia();
    } catch { /* The visible native selector remains available if GeoIP fails. */ }
    finally { clearTimeout(timer); }
    return true;
  })();
  // Keep native cart checkout in the selected Shopify market, even during detection.
  const cartForm = document.getElementById('CartForm');
  cartForm?.addEventListener('submit', async event => {
    if (event.submitter?.name !== 'checkout' || cartForm.dataset.marketChecked === 'true') return;
    event.preventDefault();
    const button = event.submitter;
    if (button.disabled) return;
    button.disabled = true;
    try {
      if (!await window.haloMarketReady) return showError();
      if (bar.dataset.country === 'AU') {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok || (await response.json()).currency !== 'AUD') return showError();
      }
      cartForm.dataset.marketChecked = 'true';
      button.disabled = false;
      cartForm.requestSubmit(button);
    } catch { showError(); }
    finally { button.disabled = false; }
  });
})();
